import React from "react";
import {
  Box,
  Grid,
  Typography,
  Paper,
  Container,
  useTheme,
} from "@mui/material";
import {
  LocalHospital,
  Storage,
  PhoneIphone,
  AccessTime,
} from "@mui/icons-material";

export default function Services() {
  const theme = useTheme();

  const services = [
    {
      icon: <LocalHospital sx={{ fontSize: 50, color: theme.palette.primary.main }} />,
      title: "Atención Médica Digital",
      description:
        "Diversas herramientas y sistemas digitales permiten a los profesionales de la salud acceder a información en tiempo real, tomar decisiones más rápidas y coordinar mejor los recursos.",
    },
    {
      icon: <Storage sx={{ fontSize: 50, color: theme.palette.primary.main }} />,
      title: "Información Centralizada",
      description:
        "La información está centralizada y estructurada de manera intuitiva para una rápida visión general del estado de cada paciente.",
    },
    {
      icon: <PhoneIphone sx={{ fontSize: 50, color: theme.palette.primary.main }} />,
      title: "Acceso Móvil Seguro",
      description:
        "El acceso se realiza desde dispositivos móviles (teléfonos, tabletas), permitiendo a enfermeras y médicos consultar y editar los datos desde cualquier lugar dentro de la instalación hospitalaria.",
    },
    {
      icon: <AccessTime sx={{ fontSize: 50, color: theme.palette.primary.main }} />,
      title: "Optimización del Tiempo",
      description:
        "Facilita la optimización del tiempo del personal, ya que la información más relevante está disponible en pocos clics.",
    },
  ];

  return (
    <Box
      sx={{
        minHeight: "100vh",
        py: { xs: 10, md: 10, lg:20, xl:20 },
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h3"
          align="center"
          fontWeight="bold"
          color="black"
          gutterBottom
        >
          Nuestros Servicios
        </Typography>

        <Typography
          variant="h6"
          align="center"
          color="text.secondary"
          sx={{ mb: 8, maxWidth: 800, mx: "auto" }}
        >
          Innovamos la atención médica a través de soluciones digitales que
          mejoran la coordinación, visibilidad y eficiencia del personal
          clínico.
        </Typography>

        <Grid container spacing={4}>
          {services.map((service, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Paper
                elevation={0}
                sx={{
                  p: 4,
                  textAlign: "center",
                  borderRadius: 3,
                  height: "100%",
                  transition: "transform 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-5px)",
                  },
                }}
              >
                <Box sx={{ mb: 2 }}>{service.icon}</Box>
                <Typography
                  variant="h6"
                  color="primary"
                  fontWeight="bold"
                  gutterBottom
                >
                  {service.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {service.description}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
